"use strict";

exports.__esModule = true;
exports.getEventDictForSwitchingBetweenItemAndAxisTriggerForTooltip = void 0;
var _constants = require("./constants");
var getEventDictForSwitchingBetweenItemAndAxisTriggerForTooltip = exports.getEventDictForSwitchingBetweenItemAndAxisTriggerForTooltip = function getEventDictForSwitchingBetweenItemAndAxisTriggerForTooltip(echartsRef) {
  return {
    "mouseover": function mouseover(e) {
      if (e.seriesType === _constants.CHART_PIE) {
        echartsRef.current.getEchartsInstance().setOption({
          tooltip: {
            trigger: "item"
          }
        });
      }
    },
    "mouseout": function mouseout(e) {
      echartsRef.current.getEchartsInstance().setOption({
        tooltip: {
          trigger: "axis"
        }
      });
    }
  };
};